import Handlebars from 'handlebars';

Handlebars.registerHelper('disclaimer', function (opt) {
  var data = ['data-disclaimer="' + opt.hash.code + '"'];
  if (opt.hash.fallback) {
    data.push('data-fallback="' + opt.hash.fallback + '"');
  }
  return new Handlebars.SafeString('<sup class="color-red footnote"><button class="js-disclaimer-lookup" ' + data.join(' ') + ' aria-haspopup="true" aria-controls=""></button></sup>');
});
